import React, {useState, useEffect} from 'react'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Select from "react-select";
import { ISelect } from '../models/General';
import Required from '../utils/Required';

const CallFeedbackForm = ({rowData,handleUpdateForm,getCallReason}:any) => {

    const userName = localStorage.getItem('name') || ''

    const [callerName, setCallerName] = useState<string>('');
    const [callReason, setCallReason] = useState<ISelect[]>()
    const [callReasonVal, setCallReasonVal] = useState('')
    const [remarksVal, setRemarksVal] = useState('')

    const [isNameChecked, setIsNameChecked] = useState(false)
    const [inputNameDisabled, setInputNameDisabled] = useState(false)

    const [nameValidate, setNameValidate] = useState(true)
    const [nameIsValid, setNameIsValid] = useState(false)
    const [nameIsInvalid, setnameIsInvalid] = useState(false)

    const [reasonValidate, setReasonValidate] = useState(true)

    const [remarksValidate, setRemarksValidate] = useState(true)
    const [remarksIsValid, setRemarksIsValid] = useState(false)
    const [remarksIsInvalid, setRemarksIsInvalid] = useState(false)

    const validName = () => {
        setNameValidate(true)
        setNameIsValid(true)
        setnameIsInvalid(false)
    }

    const invalidName = () => {
        setNameValidate(false)
        setNameIsValid(false)
        setnameIsInvalid(true)
    }

    const validReason = () => {
        setReasonValidate(true)
    }

    const invalidReason = () => {
        setReasonValidate(false)
    }

    const validRemarks = () => {
        setRemarksValidate(true)
        setRemarksIsValid(true)
        setRemarksIsInvalid(false)
    }

    const invalidRemarks = () => {
        setRemarksValidate(false)
        setRemarksIsValid(false)
        setRemarksIsInvalid(true)
    }

    const handleCallReasonSelect = (event:any) => {
        setCallReasonVal(event.value)
        validReason()
    }

    const handleInputName = (event:any) => {
        setCallerName(event.target.value)
        validName()
        if(event.target.value === ''){
            invalidName()
        }
    }

    const handleCheckName = (event:any) => {
        setIsNameChecked(event.target.checked)

        if(event.target.checked === true){
            setCallerName(userName)
            setInputNameDisabled(true)
            validName()
        }
        else{
            setCallerName('')
            setInputNameDisabled(false)
            invalidName()
        }
    }

    const handleInputRemarks = (event:any) => {
        setRemarksVal(event.target.value)
        validRemarks()
        if(event.target.value === ''){
            invalidRemarks()
        }
    }

    const handleSubmitForm = (event:any) => {
        event.preventDefault()

        if(callerName === ''){
            setNameValidate(false)
            invalidName()
        }
        if(callReasonVal === ''){
            invalidReason()
        }
        if(remarksVal === ''){
            invalidRemarks()
        }

        if(callerName !== '' && callReasonVal !== '' && remarksVal !== '' ){
            let updateParam = {callerName:callerName,callReasonId:callReasonVal,remarks:remarksVal}
            handleUpdateForm(rowData,updateParam)
        }
    }

    useEffect(() => {
        const CallReasonData = getCallReason();
        CallReasonData.then(function(result:any) {
            setCallReason(result);
        })
    },[])

    return (
        <React.Fragment>
            <div className='col-sm-12'>
                <Form onSubmit={handleSubmitForm}>
                    <Form.Group className="mb-3" controlId="caller-input">
                        <Form.Label>Caller's Name</Form.Label>
                        <Form.Control isInvalid={nameIsInvalid} isValid={nameIsValid}  disabled={inputNameDisabled} value={callerName} onChange={handleInputName} type="text" placeholder="Caller's Name" />
                        <Required isShown={nameValidate}></Required>
                        <Form.Check id="name_checkbox" onChange={handleCheckName} checked={isNameChecked} type="checkbox" label="Use logged in user's name" />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="reason-input">
                        <Form.Label>Reason</Form.Label>
                        <Select
                            name="reason"
                            placeholder="Choose Reason"
                            options={callReason}
                            onChange={handleCallReasonSelect}
                        />
                        <Required isShown={reasonValidate}></Required>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="remarks-input">
                        <Form.Label>Remarks</Form.Label>
                        <Form.Control isInvalid={remarksIsInvalid} isValid={remarksIsValid} value={remarksVal} onChange={handleInputRemarks} as="textarea" placeholder="Remarks" />
                        <Required isShown={remarksValidate}></Required>
                    </Form.Group>
                    <Button variant="primary" type="submit">
                        Submit
                    </Button>
                </Form>
            </div>
        </React.Fragment>
    )

}

export default CallFeedbackForm